import type { FC } from 'react';
import React, { createContext, useContext } from 'react';

export const RegexContext = createContext<RegExp | null>(null);

export const useRegexProvider = (): RegExp | null => {
  return useContext(RegexContext);
};

export interface FlightSummaryMetaProps {
  regex?: RegExp;
}

export const FlightSummaryMetaProvider: FC<FlightSummaryMetaProps> = ({
  regex = /.*checkout_flight_summary_results\/(.*)\//,
  children,
}) => {
  return (
    <RegexContext.Provider value={regex}>{children}</RegexContext.Provider>
  );
};

export default FlightSummaryMetaProvider;
